module.exports = __webpack_public_path__ + "img/person.cfa23142.png";